var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-pagination',{attrs:{"total-rows":_vm.total,"per-page":_vm.pageSize,"limit":_vm.limit},on:{"change":_vm.handleChangePage},model:{value:(_vm.pageNum),callback:function ($$v) {_vm.pageNum=$$v},expression:"pageNum"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }